document.addEventListener('DOMContentLoaded',()=>{
  if (document.body.classList.contains('free_pounch')) {
  fetch(`/cart.js`)
  .then((output) => output.json())
  .then((result) => {
    let MaxPricePullUp = result.item_count;
    let Total_count = 0;
    let FreeReceived = false;
    result.items.forEach((item,index)=>{
      if( item.id != 51251757515026 ){
        Total_count = parseInt(Total_count) + parseInt(item.quantity);
      }
      if(item.id == 51251757515026){
        FreeReceived = true;
        return FreeReceived;
      }
    });
    
    if( (MaxPricePullUp > 1) && !FreeReceived ){
      console.log('no removed yet');
      let ProductData = { items: [{ id: 51251757515026, quantity: 1 }] };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(ProductData),
      })
        .then((response) => {
          return response.json();
        })
        .then((results) => {
          fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector('#CartDrawer');
              document.querySelector('#CartDrawer').innerHTML = sourceQty.innerHTML;

              document.querySelectorAll('[js-image-popup]').forEach((elm)=>{
                elm.addEventListener('click', (target)=>{
                  target.preventDefault();
                  document.querySelector('.ProductPouch__free_offer').classList.add('active');
                  document.body.classList.add('masked');
                })
              })
              document.querySelectorAll('.overlayProductPouch').forEach((elm)=>{
                elm.addEventListener('click', (target)=>{
                  target.preventDefault();
                  document.querySelector('.ProductPouch__free_offer').classList.remove('active');
                  document.body.classList.remove('masked');
                })
              })
              document.querySelectorAll('.ProductPouch__cross').forEach((elm)=>{
                elm.addEventListener('click', (target)=>{
                  target.preventDefault();
                  document.querySelector('.ProductPouch__free_offer').classList.remove('active');
                  document.body.classList.remove('masked');
                })
              })  
              
            });
          fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector('.cart-count-bubble');
              document.querySelector('.cart-count-bubble').innerHTML = sourceQty.innerHTML;
            });
        })
        .catch((error) => {
          console.error('Error:', error);
        })
      
    }else if( Total_count < 2 && FreeReceived ){
      console.log('removed yet');
      let updates = {51251757515026: 0};
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then((response) => {
          return response.json();
        })
        .then((results) => {
          fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector('#CartDrawer');
              document.querySelector('#CartDrawer').innerHTML = sourceQty.innerHTML;

              document.querySelectorAll('[js-image-popup]').forEach((elm)=>{
                elm.addEventListener('click', (target)=>{
                  target.preventDefault();
                  document.querySelector('.ProductPouch__free_offer').classList.add('active');
                  document.body.classList.add('masked');
                })
              })
              document.querySelectorAll('.overlayProductPouch').forEach((elm)=>{
                elm.addEventListener('click', (target)=>{
                  target.preventDefault();
                  document.querySelector('.ProductPouch__free_offer').classList.remove('active');
                  document.body.classList.remove('masked');
                })
              })
              document.querySelectorAll('.ProductPouch__cross').forEach((elm)=>{
                elm.addEventListener('click', (target)=>{
                  target.preventDefault();
                  document.querySelector('.ProductPouch__free_offer').classList.remove('active');
                  document.body.classList.remove('masked');
                })
              })  
              
            });
          fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector('.cart-count-bubble');
              document.querySelector('.cart-count-bubble').innerHTML = sourceQty.innerHTML;
            });
        })
        .catch((error) => {
          console.error('Error:', error);
        })
      
    }
  })  
  }

  document.querySelectorAll('[js-image-popup]').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      document.querySelector('.ProductPouch__free_offer').classList.add('active');
      document.body.classList.add('masked');
    })
  })
  document.querySelectorAll('.overlayProductPouch').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      document.querySelector('.ProductPouch__free_offer').classList.remove('active');
      document.body.classList.remove('masked');
    })
  })
  document.querySelectorAll('.ProductPouch__cross').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      document.querySelector('.ProductPouch__free_offer').classList.remove('active');
      document.body.classList.remove('masked');
    })
  })  
  
})